import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

const initState = { inGame: false };

export const PreferencesContext = React.createContext(initState);

export const PreferencesProvider = ({ children, inGame = false }) => {
  const [value, setValue] = useState({ inGame });
  const { search } = useLocation();

  useEffect(() => {
    const qs = queryString.parse(search);
    if (qs.inGame) {
      setValue(prev => ({
        ...prev,
        inGame: /1|true/.test(qs.inGame),
      }));
    }
  }, [search]);

  return (
    <PreferencesContext.Provider value={value}>
      {children}
    </PreferencesContext.Provider>
  );
};

export default PreferencesContext;
